import { withHook } from 'utils/withHook';
import { useCompetitionsPreviewState } from 'containers/CompetitionsPreview/logic/useCompetitionsPreviewState';
import { CompetitionsPreviewView } from 'containers/CompetitionsPreview/view/CompetitionsPreviewView';

export const CompetitionsPreview = withHook(useCompetitionsPreviewState)(
  CompetitionsPreviewView
);
